// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("./reason/next/Next.bs.js");
var Api = require("./api");
var React = require("react");
var Scalars = require("./scalars/Scalars.bs.js");
var Intercom = require("./reason/common/Intercom.bs.js");
var AuthSession = require("./utils/AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UserSession = require("./reason/common/UserSession/UserSession.bs.js");
var Core__Promise = require("@rescript/core/src/Core__Promise.bs.js");

function fetchIntercomHash(prim) {
  return Api.fetchIntercomHash(prim !== undefined ? Caml_option.valFromOption(prim) : undefined);
}

function IntercomSessionHandler(props) {
  var intercom = Intercom.useIntercom();
  var shutdown = intercom.shutdown;
  var boot = intercom.boot;
  var update = intercom.update;
  var currentUserInfo = UserSession.useCurrentUserInfo();
  var initState = UserSession.useInitState();
  var hasBooted = React.useRef(false);
  var router = Next.useRouter();
  var pathname = Next.Router.pathname(router);
  var isImpersonated = AuthSession.useIsImpersonated();
  var authSession = AuthSession.use();
  React.useEffect((function () {
          var exit = 0;
          switch (initState) {
            case "Unauthenticated" :
                if (currentUserInfo !== undefined) {
                  
                } else {
                  if (hasBooted.current) {
                    shutdown();
                  }
                  boot(null);
                  hasBooted.current = true;
                }
                break;
            case "Agent" :
            case "Client" :
                exit = 1;
                break;
            default:
              
          }
          if (exit === 1 && currentUserInfo !== undefined) {
            var exit$1 = 0;
            switch (currentUserInfo.__typename) {
              case "Agent" :
              case "RegisteredClient" :
                  exit$1 = 2;
                  break;
              case "__unselected" :
                  break;
              
            }
            if (exit$1 === 2) {
              var id = currentUserInfo.id;
              var emailAddress = currentUserInfo.emailAddress;
              if (authSession !== undefined && authSession.__typename === "AuthSession") {
                var role = authSession.user.role;
                if (isImpersonated) {
                  var attrs = Object.fromEntries([[
                          "customAttributes",
                          Object.fromEntries([[
                                  "is_impersonating",
                                  true
                                ]])
                        ]]);
                  if (hasBooted.current) {
                    intercom.update(attrs);
                  } else {
                    boot(attrs);
                    hasBooted.current = true;
                  }
                } else {
                  Core__Promise.$$catch(Api.fetchIntercomHash(authSession.token).then(function (param) {
                            var tmp;
                            tmp = role === "AGENT" ? id : "client-" + id;
                            var attrs = Object.fromEntries([
                                  [
                                    "userId",
                                    tmp
                                  ],
                                  [
                                    "email",
                                    Scalars.EmailAddress.toString(emailAddress)
                                  ],
                                  [
                                    "userHash",
                                    param.hash
                                  ]
                                ]);
                            if (hasBooted.current) {
                              intercom.update(attrs);
                            } else {
                              boot(attrs);
                              hasBooted.current = true;
                            }
                          }), (async function (_err) {
                          
                        }));
                }
              }
              
            }
            
          }
          
        }), [
        authSession,
        currentUserInfo,
        isImpersonated,
        boot,
        shutdown,
        update,
        initState
      ]);
  React.useEffect((function () {
          if (hasBooted.current) {
            intercom.update();
          }
          
        }), [
        pathname,
        update
      ]);
}

var make = IntercomSessionHandler;

exports.fetchIntercomHash = fetchIntercomHash;
exports.make = make;
/* Next Not a pure module */
